module.exports = __webpack_public_path__ + "img/2.610677ea.png";